module.exports = __webpack_public_path__ + "static/media/BattleFury.5958ebdf.png";